import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '~/services/api/auth/authService';

@Component({
    selector: 'wep-tpl-static-heading',
    templateUrl: './heading.html',
    host: {'class': 'wep-tpl-static-heading'},
    styleUrls: ['./heading.scss'],
})
export class HeadingComponent {
    public isLoggedIn:boolean = false;
    public awthLogoPath:string;
    public mobileMenu:boolean = false;
    private router: Router;
    private authService:AuthService;

    constructor(router: Router,
        authService:AuthService) {
        this.authService = authService;
        this.router = router; 
        this.authService.hasValidAuthToken().then((isValid) => {
            this.isLoggedIn = isValid;
        });
        this.awthLogoPath = require('~/assets/images/awth-logo.png');
    }   
    public goToLogin() : void {
        this.router.navigate(['/login']);
    }
    public goToDashboard() : void {
        this.router.navigate(['/dashboard']);
    }
    public openMenu(){
        if(this.mobileMenu == true){
            this.mobileMenu = false;
        }
        else{
            this.mobileMenu = true;
        }
    }
}